import React, { useEffect, useState } from 'react';
import {
  Box, Typography, TextField, Button, Alert, CircularProgress,
  Accordion, AccordionSummary, AccordionDetails, Chip,
} from '@mui/material';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import SaveIcon from '@mui/icons-material/Save';
import { getPrices, updatePrices } from '../../services/storage';

// ── Same structure as PreisePage PRICE_DATA ──────────────────────────────────
const SECTIONS = [
  {
    id: 'einrichtung', number: '1',
    title: 'Einrichtung der Lohnbuchhaltung',
    items: [
      { labelKey: 'preise.lohn_s1_i1', label: 'Einrichten der Lohnstammdaten und des LoBu-Dienstes (einmalig)', defaultPrice: '79,90 €' },
      { labelKey: 'preise.lohn_s1_i2', label: 'Einrichten von Kurzarbeitergeld (KUG)', defaultPrice: '239,00 €' },
    ],
  },
  {
    id: 'abrechnung', number: '2',
    title: 'Brutto-/Netto-Lohnabrechnung',
    items: [
      { labelKey: 'preise.lohn_s2_i1',  label: 'Lohnabrechnung (nicht Bau) – 1 bis 5 Lohnabrechnungen',        defaultPrice: '20,00 €' },
      { labelKey: 'preise.lohn_s2_i2',  label: 'Lohnabrechnung (nicht Bau) – 6 bis 10 Lohnabrechnungen',       defaultPrice: '19,00 €' },
      { labelKey: 'preise.lohn_s2_i3',  label: 'Lohnabrechnung (nicht Bau) – ab 11 Lohnabrechnungen',          defaultPrice: '17,00 €' },
      { labelKey: 'preise.lohn_s2_i4',  label: 'Lohnabrechnung (Bau) – 1 bis 5 Lohnabrechnungen',              defaultPrice: '27,00 €' },
      { labelKey: 'preise.lohn_s2_i5',  label: 'Lohnabrechnung (Bau) – 6 bis 10 Lohnabrechnungen',             defaultPrice: '25,00 €' },
      { labelKey: 'preise.lohn_s2_i6',  label: 'Lohnabrechnung (Bau) – ab 11 Lohnabrechnungen',                defaultPrice: '23,00 €' },
      { labelKey: 'preise.lohn_s2_i7',  label: 'Wiederholungslohnlauf (je Personalnummer)',                     defaultPrice: '20,00 €' },
      { labelKey: 'preise.lohn_s2_i8',  label: 'Übernahme Mitarbeiterdaten vom Vorberater (je Mitarbeiter)',    defaultPrice: '12,90 €' },
      { labelKey: 'preise.lohn_s2_i9',  label: 'Erstanlage neuer Mitarbeiter anhand Personalfragebogen',        defaultPrice: '19,90 €' },
      { labelKey: 'preise.lohn_s2_i10', label: 'Abmeldung nach Austritt (DEÜV) / Sofortmeldung (je Pers.-Nr.)', defaultPrice: '5,00 €' },
      { labelKey: 'preise.lohn_s2_i11', label: 'Probelohnlauf (je Personalnummer)',                             defaultPrice: '15,00 €' },
      { labelKey: 'preise.lohn_s2_i12', label: 'Firmenwagenberechnungen (je Fahrzeug)',                         defaultPrice: '40,00 €' },
      { labelKey: 'preise.lohn_s2_i13', label: 'DEÜV-Jahresmeldung – Krankenversicherung',                     defaultPrice: '9,50 €' },
    ],
  },
  {
    id: 'bescheinigungen', number: '3',
    title: 'Bescheinigungen / SV-Anmeldungen / Meldungen',
    items: [
      { labelKey: 'preise.lohn_s3_i1', label: 'Arbeitgeberbescheinigung (Arbeitsamt) (je Pers.-Nr.)',                defaultPrice: '32,00 €' },
      { labelKey: 'preise.lohn_s3_i2', label: 'Elektronische Verdienstbescheinigung (KV, Landratsamt) (je Pers.-Nr.)', defaultPrice: '32,00 €' },
      { labelKey: 'preise.lohn_s3_i3', label: 'Elektronische Lohnsteuerbescheinigung je Mitarbeiter',                 defaultPrice: '9,90 €' },
      { labelKey: 'preise.lohn_s3_i4', label: 'Jahresmeldung – Schwerbehindertenanzeige',                             defaultPrice: '49,90 €' },
      { labelKey: 'preise.lohn_s3_i5', label: 'Jahresmeldung – Verdienstnachweis Berufsgenossenschaft',               defaultPrice: '49,90 €' },
      { labelKey: 'preise.lohn_s3_i6', label: 'A1-Bescheinigung je Bescheinigung',                                    defaultPrice: '65,00 €' },
    ],
  },
  {
    id: 'antraege', number: '4',
    title: 'Anträge',
    items: [
      { labelKey: 'preise.lohn_s4_i1', label: 'Antrag auf Fortzahlung (AAG-Erstattung) – Krankheit, Schwangerschaft, Beschäftigungsverbot (je Mitarbeiter)', defaultPrice: '16,50 €' },
      { labelKey: 'preise.lohn_s4_i2', label: 'Sonstige Lohnanträge',                                                                                         defaultPrice: '118,00 €' },
    ],
  },
  {
    id: 'nebenleistungen', number: '5',
    title: 'Neben-/Zusatzleistungskosten',
    items: [
      { labelKey: 'preise.lohn_s5_i1', label: 'Datenbeistellung für externe Betriebsprüfung (ESt/KSt/LSt)',                  defaultPrice: '74,90 €' },
      { labelKey: 'preise.lohn_s5_i2', label: 'Datenbeistellung / -übermittlung für euBP (DRV-Bund)',                        defaultPrice: '74,90 €' },
      { labelKey: 'preise.lohn_s5_i3', label: 'Begleitung sonstiger Tätigkeiten (SEPA-Mandat, Betriebsnummernregistrierung)', defaultPrice: '60,00 €' },
      { labelKey: 'preise.lohn_s5_i4', label: 'Büro- und Servicepauschale pro Abrechnungszeitraum – bis 10 Mitarbeiter',     defaultPrice: '9,90 €' },
      { labelKey: 'preise.lohn_s5_i5', label: 'Büro- und Servicepauschale pro Abrechnungszeitraum – bis 20 Mitarbeiter',     defaultPrice: '19,90 €' },
      { labelKey: 'preise.lohn_s5_i6', label: 'Büro- und Servicepauschale pro Abrechnungszeitraum – ab 21 Mitarbeiter',      defaultPrice: '39,90 €' },
    ],
  },
  {
    id: 'beratungen', number: '6',
    title: 'Beratung / Zeithonorar',
    items: [
      { labelKey: 'preise.lohn_s6_i1', label: 'Prüfungen im Lohnbereich (LSt, DRV, BG, KSK)', defaultPrice: '110,00 €' },
      { labelKey: 'preise.lohn_s6_i2', label: 'Begleitung bei Prüfung',                         defaultPrice: '110,00 €' },
      { labelKey: 'preise.lohn_s6_i3', label: 'Personalverwaltung',                              defaultPrice: '60,00 €' },
    ],
  },
];

type PriceState = Record<string, string>; // labelKey → price

const AdminPreise: React.FC = () => {
  const [prices, setPrices] = useState<PriceState>({});
  const [loading, setLoading] = useState(true);
  const [saving, setSaving] = useState(false);
  const [success, setSuccess] = useState(false);
  const [error, setError] = useState<string | null>(null);

  useEffect(() => {
    getPrices()
      .then((map) => {
        // Seed local state: API value first, fallback to default
        const initial: PriceState = {};
        SECTIONS.forEach((s) =>
          s.items.forEach((item) => {
            initial[item.labelKey] = map[item.labelKey] ?? item.defaultPrice;
          })
        );
        setPrices(initial);
      })
      .catch(() => {
        // If API fails, use defaults
        const initial: PriceState = {};
        SECTIONS.forEach((s) => s.items.forEach((item) => { initial[item.labelKey] = item.defaultPrice; }));
        setPrices(initial);
      })
      .finally(() => setLoading(false));
  }, []);

  const handleChange = (labelKey: string, value: string) => {
    setPrices((prev) => ({ ...prev, [labelKey]: value }));
  };

  const handleSave = async () => {
    setSaving(true);
    setError(null);
    setSuccess(false);
    try {
      const items = Object.entries(prices).map(([label_key, price]) => ({ label_key, price }));
      await updatePrices(items);
      setSuccess(true);
      setTimeout(() => setSuccess(false), 3000);
    } catch {
      setError('Fehler beim Speichern. Bitte erneut versuchen.');
    } finally {
      setSaving(false);
    }
  };

  if (loading) {
    return (
      <Box sx={{ display: 'flex', justifyContent: 'center', pt: 8 }}>
        <CircularProgress />
      </Box>
    );
  }

  return (
    <Box>
      {/* Header */}
      <Box sx={{ display: 'flex', alignItems: 'flex-start', justifyContent: 'space-between', mb: 4, flexWrap: 'wrap', gap: 2 }}>
        <Box>
          <Typography variant="h4" sx={{ fontWeight: 700 }}>Lohnpreise verwalten</Typography>
          <Typography variant="body2" sx={{ color: 'text.secondary', mt: 1 }}>
            Preise für die Lohnbuchhaltungs-Preisliste bearbeiten.
          </Typography>
        </Box>
        <Button
          variant="contained"
          startIcon={saving ? <CircularProgress size={16} color="inherit" /> : <SaveIcon />}
          onClick={handleSave}
          disabled={saving}
          sx={{ minWidth: 160 }}
        >
          {saving ? 'Speichert…' : 'Alle speichern'}
        </Button>
      </Box>

      {success && <Alert severity="success" sx={{ mb: 3 }}>Preise erfolgreich gespeichert.</Alert>}
      {error   && <Alert severity="error"   sx={{ mb: 3 }} onClose={() => setError(null)}>{error}</Alert>}

      {/* Sections */}
      <Box sx={{ display: 'flex', flexDirection: 'column', gap: 1.5 }}>
        {SECTIONS.map((section) => (
          <Accordion key={section.id} defaultExpanded={section.items.length <= 3} disableGutters elevation={0}
            sx={{ border: '1px solid #e8e8f0', borderRadius: '8px !important', '&:before': { display: 'none' } }}
          >
            <AccordionSummary expandIcon={<ExpandMoreIcon />} sx={{ px: 3, py: 1.5 }}>
              <Box sx={{ display: 'flex', alignItems: 'center', gap: 2 }}>
                <Chip label={section.number} size="small" sx={{ bgcolor: '#1e3a5f', color: 'white', fontWeight: 700, width: 28, height: 28, borderRadius: '50%' }} />
                <Typography sx={{ fontWeight: 600, fontSize: '0.95rem' }}>{section.title}</Typography>
                <Typography variant="caption" sx={{ color: 'text.secondary' }}>({section.items.length} Positionen)</Typography>
              </Box>
            </AccordionSummary>
            <AccordionDetails sx={{ px: 3, pb: 3, pt: 0 }}>
              <Box sx={{ display: 'flex', flexDirection: 'column', gap: 1.5 }}>
                {section.items.map((item) => (
                  <Box key={item.labelKey} sx={{ display: 'flex', alignItems: 'center', gap: 2, py: 1, borderBottom: '1px solid #f5f5fa' }}>
                    <Typography sx={{ flex: 1, fontSize: '0.875rem', color: '#333', lineHeight: 1.5 }}>
                      {item.label}
                    </Typography>
                    <TextField
                      value={prices[item.labelKey] ?? item.defaultPrice}
                      onChange={(e) => handleChange(item.labelKey, e.target.value)}
                      size="small"
                      sx={{ width: 140 }}
                      inputProps={{ style: { textAlign: 'right', fontWeight: 600, fontSize: '0.9rem' } }}
                    />
                  </Box>
                ))}
              </Box>
            </AccordionDetails>
          </Accordion>
        ))}
      </Box>

      {/* Bottom Save */}
      <Box sx={{ mt: 4, display: 'flex', justifyContent: 'flex-end' }}>
        <Button
          variant="contained"
          startIcon={saving ? <CircularProgress size={16} color="inherit" /> : <SaveIcon />}
          onClick={handleSave}
          disabled={saving}
          size="large"
        >
          {saving ? 'Speichert…' : 'Alle speichern'}
        </Button>
      </Box>
    </Box>
  );
};

export default AdminPreise;
